<app-loading *ngIf="contentReady"></app-loading>
<div class="addresses-container" [class.marginbottom]="!isCreateOrder"
    *ngIf="addresses.length > 0; else emptyAddresses">
    @if(isCreateOrder){
    <p>
        <img class="profile-icon" src="/assets/e-commerce/icons/02_address.svg">
        {{'Select Address' | transloco}}

    </p>
    }
    <div class="address-card" [class.pointer]="isCreateOrder" [class.active]="selectedAddress?.id === item.id"
        *ngFor="let item of addresses; let isFirst = first" (click)="chooseAddress(item)">
        @if(!isCreateOrder){

        <div class="address-card-header">
            <span class="label">{{item.address_title}}</span>

            <a class="edit-link pointer red" (click)="delete(item.id);$event.stopPropagation()"><i
                    class="fa-solid fa-xmark"></i></a>

        </div>
        <p class="details">{{item.city.city_name_ar}},{{item.government.governorate_name_ar}}</p>
        <p class="details">{{item.address}}</p>
        @if(item.location_link){

        <p class="phone">
            <a [href]="item.location_link" target="_blank" class="edit-link">{{ "Google Maps Link" | transloco }}</a>
        </p>

        }

        }
        @else{
        <div class="address-card-header">
            <span>{{item.address_title}}:

                {{item.city.city_name_ar}},{{item.government.governorate_name_ar}} , {{item.address}}
            </span>

            <div class="quantity-controls" *ngIf="isFirst">
                <label>{{ "new Address" | transloco }}</label>
                <button routerLink="/addaddress">+</button>
            </div>

        </div>
        }
    </div>
    @if(!isCreateOrder){
    <div class="cart-summary">
        <button class="checkout-btn" routerLink="/addaddress"> {{ "Add Address" | transloco }}</button>
    </div>
    }
</div>
<ng-template #emptyAddresses>
    <app-emptyaddresses *ngIf="!contentReady"></app-emptyaddresses>
</ng-template>